import React, { useState, useEffect } from 'react';
import { ExternalLink } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { getSistemaInfo } from '../utils/sistemaInfo';

const Footer: React.FC = () => {
  const { empresaSelecionada } = useAuth();
  const cnaeEmpresa = (empresaSelecionada as any)?.cnae_principal;
  const tipoComissaoBanco = (empresaSelecionada as any)?.tipo_comissao;
  const nomeEmpresa = (empresaSelecionada as any)?.nome;
  
  const [sistemaInfo, setSistemaInfo] = useState({
    nome: 'CIPA FÁCIL',
    nomeCompleto: 'CIPA FÁCIL EHS',
    descricao: 'Sistema Completo de Gestão CIPA - 100% Conforme NR-05',
    descricaoCurta: 'Sistema 100% Conforme NR-05 Vigente',
    tipo: 'CIPA' as 'CIPA' | 'CIPAMIN' | 'CIPATR',
    norma: 'NR-05'
  });

  useEffect(() => {
    getSistemaInfo(cnaeEmpresa, tipoComissaoBanco, nomeEmpresa).then(setSistemaInfo);
  }, [cnaeEmpresa, tipoComissaoBanco, nomeEmpresa]);
  
  return (
    <footer className="bg-white border-t border-gray-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <p className="text-gray-600 text-sm">
              <strong>{sistemaInfo.nomeCompleto}</strong> - {sistemaInfo.descricaoCurta}
            </p>
            <p className="text-gray-500 text-xs mt-1">
              Desenvolvido com base na Portaria MTP nº 4.219/2022 - Garantia total de conformidade legal
            </p>
          </div>
          
          <div className="text-center md:text-right">
            <p className="text-gray-600 text-sm mb-2">
              Desenvolvido por
            </p>
            <a 
              href="https://mmsolutec.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors font-medium"
            >
              <span className="text-lg font-bold">MM Solutec</span>
              <ExternalLink className="w-4 h-4" />
            </a>
            <p className="text-gray-500 text-xs mt-1">
              © 2025 MMSolutec. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
